export default "__VITE_ASSET__vuER_ELQ__"